<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>能力系统配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importUploadSuccess(res)}" :headers="headers">
                <el-button v-permisaction="['config:capacityConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button v-permisaction="['config:capacityConfig:export']" type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
            </el-col>
            <el-button v-permisaction="['config:capacityConfig:add']" size="mini" type="primary" @click="onSubmit()">保存</el-button>
            <el-col :span="1.5"> <clear-cache-apply /><sync-data /></el-col>
          </el-row>
        </div>
        <el-table border :data="formData" style="width: 100%">
          <el-table-column align="center" prop="type" label="能力ID" width="80px">
            <template v-slot:default="scope">
              {{ scope.row.type }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="type" label="能力类型" width="150px">
            <template v-slot:default="scope">
              {{ getCapTypeVal(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="unlock_star" width="100px" label="解锁星星数" />
          <el-table-column align="center" prop="lang_key" label="多语言KEY" width="200px" />
          <el-table-column align="center" label="等级" width="200px">
            <template v-slot:default="scope">
              <el-table :data="scope.row.config" border :show-header="false">
                <el-table-column align="center" prop="level" label="等级" />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="能力" width="220px">
            <template v-slot:default="scope">
              <el-table :data="scope.row.config" border :show-header="false">
                <el-table-column align="center" prop="level" label="等级">
                  <template v-slot:default="scope">
                    {{ getCateTypeVal(scope.row.ability) }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="加成数值/倍数" width="180px">
            <template v-slot:default="scope">
              <el-table :data="scope.row.config" border :show-header="false">
                <el-table-column align="center" prop="bonus" label="等级" />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所需星星数" width="180px">
            <template v-slot:default="scope">
              <el-table :data="scope.row.config" border :show-header="false">
                <el-table-column align="center" prop="star" label="所需星星数" />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="背景板" width="180px">
            <template v-slot:default="scope">
              <el-table :data="scope.row.config" border :show-header="false">
                <el-table-column align="center" prop="backdrop" label="背景板">
                  <template v-slot:default="scope">
                    <el-select v-model.number="scope.row.backdrop" style="width: 130px;" placeholder="请选择">
                      <el-option v-for="item in backdropSelect" :key="item.id" :label="item.title" :value="item.id" />
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="奖励" width="180px">
            <template v-slot:default="scope">
              <el-table :data="scope.row.config" border :show-header="false">
                <el-table-column align="center" prop="star" label="奖励">
                  <template v-slot:default="scope">
                    <span v-if="scope.row.reward.length <= 0">-</span>
                    <span v-else>{{ getRewardList(scope.row.reward) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:capacityConfig:del']" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
              <el-button v-permisaction="['config:capacityConfig:add']" size="mini" @click="dialogVisible[scope.$index].visible = true">配置</el-button>
              <el-drawer title="配置" :visible.sync="dialogVisible[scope.$index].visible" size="1100px" :before-close="(d)=>{return handleClose(d, scope.$index)}">
                <el-form :inline="true">
                  <el-row v-for="(c, ci) in scope.row.config" :key="ci">
                    <el-form-item label="等级">
                      <el-input v-model.number="c.level" style="width: 100px;" placeholder="等级" />
                    </el-form-item>
                    <el-form-item label="能力">
                      <el-select v-model.number="c.ability" style="width: 130px;" placeholder="请选择">
                        <el-option v-for="item in cateType" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="cateTypeArr.includes(c.ability) ? '加成数值' : '倍数'">
                      <el-input v-model.number="c.bonus" style="width: 100px;" placeholder="加成数值" />
                    </el-form-item>
                    <el-form-item label="所需星星数">
                      <el-input v-model.number="c.star" style="width: 100px;" placeholder="所需星星数" />
                    </el-form-item>
                    <el-form-item label="背景板">
                      <el-select v-model.number="c.backdrop" style="width: 130px;" placeholder="请选择">
                        <el-option v-for="item in backdropSelect" :key="item.id" :label="item.title" :value="item.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="奖励配置">
                      <el-button type="text" icon="el-icon-edit" @click="langVisibleArr[scope.$index][ci].visible = true">奖励配置</el-button>
                      <el-dialog :before-close="(d)=>{return handleRewardClose(d, scope.$index, ci)}" style="overflow-y: auto" title="奖励配置" width="950px" :visible="langVisibleArr[scope.$index][ci].visible" append-to-body>
                        <commonReward v-model="c.reward" />
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="langVisibleArr[scope.$index][ci].visible = false">取 消</el-button>
                          <el-button type="primary" @click="langVisibleArr[scope.$index][ci].visible = false">确 定</el-button>
                        </div>
                      </el-dialog>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="danger" @click="delConfig(scope.$index, ci)">删除</el-button>
                    </el-form-item>
                  </el-row>
                </el-form>
                <el-button style="margin-top: 5px" @click="addConfig(scope.$index)">+</el-button>
              </el-drawer>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  delAbilityCfg,
  exportAbilityCfg, getAbilityCapType,
  getAbilityCfgList,
  importAbilityCfg,
  updateAbilityCfg
} from '@/api/config/ability-cfg'
import { getRewardType } from '@/api/config/slot'
import { getRewardListForPropsId } from '@/utils'
import commonReward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'CapacityConfig',
  components: {
    SyncData,
    ClearCacheApply,
    commonReward
  },
  data() {
    return {
      loading: false,
      langVisibleArr: [[{ visible: false }]],
      dialogVisible: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 100
      },
      rewardType: [],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      capType: [],
      cateType: [],
      backdropSelect: [
        { id: 0, title: '咖色' },
        { id: 1, title: '蓝色' },
        { id: 2, title: '银色' },
        { id: 3, title: '金色' },
        { id: 4, title: '幻彩' }
      ],
      cateTypeArr: [4, 5],
      formData: [
        {
          'id': 0,
          'unlock_star': 1,
          'reward': { type: 1, ability: 1, num: 1 },
          'lang_key': ''
        }
      ],
      skinId: [62, 19],
      chessId: [],
      areaId: [] }
  },
  created() {
    this.getCapType()
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    handleClose(d, index) {
      this.dialogVisible[index].visible = false
    },
    handleRewardClose(d, index, i) {
      this.langVisibleArr[index][i].visible = false
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.type === 0 || _data.type === undefined) {
          this.msgError('请选择类型')
          return
        }
        if (_data.lang_key === '') {
          this.msgError('多语言KEY不能为空')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateAbilityCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getCapType() {
      getAbilityCapType().then(res => {
        if (res.code === 200) {
          this.capType = []
          this.cateType = []
          const capType = res.data.cayType
          for (const i in capType) {
            const val = capType[i]
            this.capType.push({ label: val, value: parseInt(i), disabled: false })
          }

          const cateType = res.data.cate
          for (const i in capType) {
            const val = cateType[i]
            this.cateType.push({ label: val, value: parseInt(i), disabled: false })
          }
        }
      })
    },
    getTables() {
      getAbilityCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          // this.total = res.data.count
          for (const i in this.capType) {
            this.capType[i].disabled = false
          }
          res.data.forEach((item, index) => {
            this.dialogVisible.push({ visible: false })
            for (const i in this.capType) {
              const val = this.capType[i]
              if (val.value === item.type) {
                this.capType[i].disabled = true
              }
            }
            this.$set(this.langVisibleArr, index, [])
            item.config.forEach((c) => {
              this.langVisibleArr[index].push({ visible: false })
            })
          })
          this.formData = res.data
          // console.log(this.capType)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      const len = this.formData.length
      this.formData.push({
        'id': 0,
        'unlock_star': 1,
        'reward': { type: 1, ability: 1, num: 1 },
        'lang_key': '',
        config: []
      })
      this.langVisibleArr.push({ visible: false })
      this.$set(this.langVisibleArr, len, [])
    },
    del(id) {
      console.log(id)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAbilityCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importAbilityCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      // window.open(process.env.VUE_APP_BASE_API + '/api/v1/ability/export')
      exportAbilityCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addConfig(index) {
      const len = this.formData[index].config.length
      this.langVisibleArr[index].push({ visible: false })
      this.formData[index].config.push({
        level: len + 1,
        bonus: 0,
        type: 1,
        star: 0,
        ability: 1,
        backdrop: 1,
        reward: [{ propsId: 1, num: 1, skin: 1, rtype: 1 }]
      })
    },
    delConfig(index, ci) {
      this.formData[index].config = this.formData[index].config.filter((res, key) => {
        return ci !== key
      })
    },
    addReward(index, ci) {
      this.formData[index].config[ci].reward.push({ propsId: 1, num: 1, skin: 1, rtype: 1 })
    },
    removeReward(index, ci, i) {
      this.formData[index].config[ci].reward = this.formData[index].config[ci].reward.filter((res, key) => {
        return i !== key
      })
    },
    confirmConfig(index) {
      this.dialogVisible[index].visible = false
      this.onSubmit()
    },
    getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    },
    getCapTypeVal(type) {
      let text = ''
      for (const i in this.capType) {
        const val = this.capType[i]
        if (val.value === type) {
          text = val.label
          break
        }
      }
      return text
    },
    getCateTypeVal(type) {
      let text = ''
      for (const i in this.cateType) {
        const val = this.cateType[i]
        if (val.value === type) {
          text = val.label
          break
        }
      }
      return text
    }
  }
}
</script>

<style scoped>
</style>
